import { render, staticRenderFns } from "./deanTabBar.vue?vue&type=template&id=0f66fa22&scoped=true"
import script from "./deanTabBar.vue?vue&type=script&lang=ts"
export * from "./deanTabBar.vue?vue&type=script&lang=ts"
import style0 from "./deanTabBar.vue?vue&type=style&index=0&id=0f66fa22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f66fa22",
  null
  
)

export default component.exports